import { FC } from 'react';
import { TypeLikeDislikeProps } from '../Types.types';
import { AllieDislikeIcon, AllieLikeIcon } from '../../../../../styling/icons';
import { StyledContainer, StyledLikeDislikeOutline } from './Outline.styles';

export const Outline: FC<TypeLikeDislikeProps> = ({ selected, size, onChange, disabled }) => {
  return (
    <StyledContainer value={selected} size={size} disabled={disabled}>
      <StyledLikeDislikeOutline
        value="true"
        allieColor="white"
        size={size}
        onClick={(e: any) =>
          onChange({ ...e, detail: { value: selected !== 'true' ? 'true' : undefined } })
        }
      >
        <AllieLikeIcon
          size={`${size}`}
          allieColor={`${selected === 'true' ? 'neutral-60' : 'neutral-30'}`}
        />
      </StyledLikeDislikeOutline>
      <StyledLikeDislikeOutline
        value="false"
        allieColor="white"
        size={size}
        onClick={(e: any) =>
          onChange({ ...e, detail: { value: selected !== 'false' ? 'false' : undefined } })
        }
      >
        <AllieDislikeIcon
          size={`${size}`}
          allieColor={`${selected === 'false' ? 'neutral-60' : 'neutral-30'}`}
        />
      </StyledLikeDislikeOutline>
    </StyledContainer>
  );
};
